// extracted by mini-css-extract-plugin
export default {"root":"NKMAsxiFQ1vHfVYzmReA","text":"ygEpTiZvJHxIy5UYtmUU"};